export const slrOptions = {
  caption: {
    captionColor: "white",
    captionFontFamily: "Times New Roman', Times, serif",
    captionFontWeight: "300",
    captionFontSize: "5rem",
    captionTextTransform: "uppercase",
  }
};


// WEBPACK FOOTER //
// ./src/constants/constants.js